import { render, staticRenderFns } from "./CoalTaxCalc.vue?vue&type=template&id=516834f8&"
import script from "./CoalTaxCalc.vue?vue&type=script&lang=js&"
export * from "./CoalTaxCalc.vue?vue&type=script&lang=js&"
import style0 from "./CoalTaxCalc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports